import axios from "axios";

const CRM_URL = process.env.REACT_APP_CRM_URL;
const CRM_CLIENT_ID = process.env.REACT_APP_CRM_CLIENT_ID;

// The field values land inside HTML email bodies, so escape them before interpolating.
const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const saveContact = async (data) => {
  const name = escapeHtml(data.get("name"));
  const phone = escapeHtml(data.get("phone"));
  const email = escapeHtml(data.get("email"));
  const message = escapeHtml(data.get("message"));

  const admin_subject = `Lead from website`;
  const admin_message = `Hello Team,<br/>${name} is trying to contact you.<br/><br/>Details are as follows.<br/>Name: ${name}<br/>Mobile: ${phone}<br/>Email: ${email}<br/>Message: ${message}
  `;
  const subject = `Proactimo Website Team`;
  const reply = `Hello ${name}, <br/><br/> Thank you for contacting us. <br/> We'll get back to you soon.<br/><br/>Regards,<br/>Team Proactimo.`;

  const params = new URLSearchParams({
    subject,
    message: reply,
    to: data.get("email"),
    admin_subject,
    admin_message,
  });
  const url = `${CRM_URL}/openapi/clientsmtp/${CRM_CLIENT_ID}/contactus/?${params.toString()}`;

  try {
    await axios.post(url, data, { timeout: 15000 });
    return true;
  } catch (err) {
    return false;
  }
};

export default saveContact;
